import React from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../constants/Properties'
import { setMessageModal, initializeBroadcastChannel, unloadBroadcastChannel } from '../actions/generalActions'
import { getTranslation } from '../actions/dataActions'
import TouchKeyboard from '../components/TouchKeyboard'
import SelectModal from './SelectModal'
import SplashModal from './SplashModal'
import ConfirmModal from './ConfirmModal'
import ConfigurationModal from './ConfigurationModal'
import SplitReceiptModal from '../modal/components/SplitReceiptModal/SplitReceiptModal'
import ReceiptModal from '../modal/components/ReceiptModal'
import SearchModal from '../modal/components/SearchModal'
import PaymentModal from '../modal/components/PaymentModal'
import WeighModal from '../modal/components/WeighModal'
import DatePickerModal from '../modal/components/DatePickerModal'
import CustomerBaseModal from '../modal/components/CustomerBaseModal'
import ArticleBaseModal from '../modal/components/ArticleBaseModal'
import TicketBaseModal from '../modal/components/TicketBaseModal'
import SelectPagerModal from '../modal/components/SelectPagerModal'
import ConfigurationListModal  from '../modal/components/ConfigurationListModal'
import ManagerLoginModal from '../modal/components/ManagerLoginModal'
import OrderListModal from '../modal/components/OrderListModal'
import OrderConfirmationModal from '../modal/components/OrderConfirmationModal'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'
import ChangeModal from '../modal/components/ChangeModal'
import InputModal from '../modal/components/InputModal'
import CreateCustomerModal from '../modal/components/CreateCustomerModal'
import CreateTicketModal from '../modal/components/CreateTicketModal'
import InvoiceModal from '../modal/components/InvoiceModal'
import SetInvoiceInfoModal from '../modal/components/SetInvoiceInfoModal'
import ReservationModal from '../modal/components/ReservationModal'
import CustomerExistsModal from '../modal/components/CustomerExistsModal'
import AddBalanceToTicketModal from '../modal/components/AddBalanceToTicketModal'
import CashRegistrationModal from '../modal/components/CashRegistrationModal'

class App extends React.Component {
  constructor(props) {
    super(props);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.state = {
      noninteractive: false,
    };
  }

  handleNonInteractive = e => {
    const windowNonInteractive = window.noninteractive;
    this.setState(prevState => {
      return {
        noninteractive: windowNonInteractive
      }
    });
    if(windowNonInteractive){
      this.props.setMessageModal(true, this.props.getTranslation(resource.EXTRA_TAB_NOT_ALLOWED));
    }
  }

  componentDidMount() {
    var url = window.location.href;
    if (!url.includes('/customerdisplay')) {
      window.addEventListener("resize", this.handleNonInteractive);
      initializeBroadcastChannel();
    }
    $(document).on('touchmove', function (e) {
      if (!$(e.target).parents('.lines')[0]
        && !$(e.target).parents('.configurationModalValuesContent')[0]
        && !$(e.target).parents('.receipt-body')[0]) {
        e.preventDefault();
      }
    });
    //$(document).bind('touchmove', false);
    Modal.setAppElement('body');
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleNonInteractive);
    unloadBroadcastChannel();
  }

  closeErrorModal() {
    this.props.setMessageModal(false, 'default');
  }

  render() {
    const nonInteractive = this.state.noninteractive;
    const showBlackboxMessage = (this.props.blackboxstatus.ErrorCode > -1 && this.props.blackbox);

    let blackboxMessage = this.props.blackboxstatus.ErrorMessage;
    if (this.props.blackboxstatus.ErrorCode > 0) {
      blackboxMessage = `${this.props.blackboxstatus.ErrorCode}: ${blackboxMessage}`;
    }

    const loading = this.props.getTranslation(resource.LOADING);
    const ok = this.props.getTranslation(resource.OK);

    return !(nonInteractive === undefined || nonInteractive === false) ? (
<div id="general">

<Modal class="reactModal" contentLabel="" isOpen={this.props.messageModal.show} style={properties.errorModalStyle}
        >
<div className="generalModalContent">
<div className="generalModalText">
              {this.props.messageModal.message}
</div>
<div className="generalModalButtons">
</div>
</div>
</Modal>
</div>
    )
    : (
<div id="general">
        {this.props.children}
  <Modal class="reactModal" contentLabel="" isOpen={this.props.isLoading} style={properties.loaderModalStyle}
        >
<div className="loader">
            {loading}
  </div>
</Modal>
<Modal class="reactModal" contentLabel="" isOpen={showBlackboxMessage} style={properties.errorModalStyle}
        >
<div className="generalModalContent">
  <div className="generalModalText">
              {blackboxMessage}
  </div>
</div>
</Modal>
<SplashModal />
<ReceiptModal />
<SelectModal />
<ConfirmModal />
<TouchKeyboard />
<ConfigurationModal />
<SplitReceiptModal />
<SearchModal />
<PaymentModal />
<WeighModal />
<DatePickerModal />
<CustomerBaseModal />
<ArticleBaseModal />
<TicketBaseModal />
<SelectPagerModal />
<ConfigurationListModal />
<ManagerLoginModal />
<OrderListModal />
<OrderConfirmationModal />
<ChangeModal />
<InputModal />
<CreateCustomerModal />
<CreateTicketModal />
<InvoiceModal />
<SetInvoiceInfoModal />
<ReservationModal />
<CustomerExistsModal />
<AddBalanceToTicketModal />
<CashRegistrationModal />
<Modal class="reactModal" contentLabel="" isOpen={this.props.messageModal.show} style={properties.errorModalStyle}
        >
<div className="generalModalContent">
<div className="generalModalText">
              {this.props.messageModal.message}
</div>
<div className="generalModalButtons">
  <button className="generalModalButton generalDeny" onClick={this.closeErrorModal}>
                {ok}
              </button>
</div>
</div>
</Modal>
</div>
    )
  }
}

App.propTypes = {
  children: PropTypes.element,
  isPosting: PropTypes.bool,
  isLoading: PropTypes.bool,
  tempRights: PropTypes.number,
  paymentMethods: PropTypes.array,
  devices: PropTypes.array,
  setMessageModal: PropTypes.func.isRequired,
  messageModal: PropTypes.object,
  ok: PropTypes.string,
  blackbox: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    isPosting: state.receiptState.receipt.isPosting,
    isLoading: state.generalState.isLoading,
    tempRights: state.generalState.tempRights,
    paymentMethods: state.generalState.paymentMethod.all,
    devices: state.generalState.devices,
    messageModal: state.generalState.modal.messageModal,
    blackboxstatus: state.generalState.blackboxstatus,
    blackbox: state.generalState.licenses.blackbox
  }
}

export default connect(mapStateToProps, { 
  setMessageModal, 
  getTranslation,
  initializeBroadcastChannel,
  unloadBroadcastChannel 
})(App)



// WEBPACK FOOTER //
// src/components/App.jsx